'use client';
import type { ReactNode } from 'react';
import { FieldValues, FormProvider as Form, SubmitHandler, type UseFormReturn } from 'react-hook-form';

// ----------------------------------------------------------------------

interface FormProviderProps<TFieldValues extends FieldValues = FieldValues> extends UseFormReturn<TFieldValues> {
  className?: string;
  children?: ReactNode;
  onSubmit: SubmitHandler<TFieldValues>;
  id?: string;
}

export function FormProvider<TFieldValues extends FieldValues = FieldValues>({
  children,
  className,
  onSubmit,
  id,
  ...props
}: FormProviderProps<TFieldValues>) {
  return (
    <Form {...props}>
      <form id={id} className={className} onSubmit={props.handleSubmit(onSubmit)}>
        {children}
      </form>
    </Form>
  );
}
